
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Body cell custom" fileName="body-cell.md" />
        <demo-block>
        <div><p>1、In the<code>column</code> option, the rendering function can be passed in through the attribute <code>renderBodyCell({row,column,rowIndex},h)</code><br>2、The render function takes 3 parameters,<code>row</code>:Current row data、<code>column</code>:Current column option、<code>rowIndex</code>:Row index</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table style=&quot;width:100%&quot; border-y :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;#&quot;,
                        align: &quot;center&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return (
                                &lt;span class=&quot;text-bold&quot; style=&quot;color:#1890ff;&quot;&gt;
                                    {++rowIndex}
                                &lt;/span&gt;
                            );
                        },
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Date&quot;,
                        align: &quot;center&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;left&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            const text = row[column.field];
                            return (
                                &lt;span&gt;
                                    &lt;a
                                        class=&quot;test-text&quot;
                                        href=&quot;http://github.com&quot;
                                        style=&quot;color:#1890ff;cursor:pointer;&quot;
                                    &gt;
                                        {text}
                                    &lt;/a&gt;
                                    &amp;nbsp;are my hobbies
                                &lt;/span&gt;
                            );
                        },
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            const text = row[column.field];
                            return &lt;input style=&quot;width:100%&quot; value={text}&gt;&lt;/input&gt;;
                        },
                    },
                    {
                        field: &quot;&quot;,
                        key: &quot;e&quot;,
                        title: &quot;Action&quot;,
                        width: &quot;&quot;,
                        center: &quot;left&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return (
                                &lt;span&gt;
                                    &lt;button
                                        class=&quot;button-demo&quot;
                                        on-click={() =&gt; this.editRow(rowIndex)}
                                    &gt;
                                        Edit
                                    &lt;/button&gt;
                                    &amp;nbsp;
                                    &lt;button
                                        class=&quot;button-demo&quot;
                                        on-click={() =&gt; this.deleteRow(rowIndex)}
                                    &gt;
                                        Delete
                                    &lt;/button&gt;
                                &lt;/span&gt;
                            );
                        },
                    },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
            };
        },
        methods: {
            editRow(rowIndex) {
                alert(`eidt row number:${rowIndex}`);
            },
            deleteRow(rowIndex) {
                this.tableData.splice(rowIndex, 1);
            },
        },
    };
&lt;/script&gt;

&lt;style&gt;
    .text-bold {
        font-weight: bold;
    }
&lt;/style&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{staticStyle:{"width":"100%"},attrs:{"border-y":"","columns":_vm.columns,"table-data":_vm.tableData}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "#",
                        align: "center",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return (
                                <span class="text-bold" style="color:#1890ff;">
                                    {++rowIndex}
                                </span>
                            );
                        },
                    },
                    {
                        field: "date",
                        key: "b",
                        title: "Date",
                        align: "center",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        align: "left",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            const text = row[column.field];
                            return (
                                <span>
                                    <a
                                        class="test-text"
                                        href="http://github.com"
                                        style="color:#1890ff;cursor:pointer;"
                                    >
                                        {text}
                                    </a>
                                    &nbsp;are my hobbies
                                </span>
                            );
                        },
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            const text = row[column.field];
                            return <input style="width:100%" value={text}></input>;
                        },
                    },
                    {
                        field: "",
                        key: "e",
                        title: "Action",
                        width: "",
                        center: "left",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return (
                                <span>
                                    <button
                                        class="button-demo"
                                        on-click={() => this.editRow(rowIndex)}
                                    >
                                        Edit
                                    </button>
                                    &nbsp;
                                    <button
                                        class="button-demo"
                                        on-click={() => this.deleteRow(rowIndex)}
                                    >
                                        Delete
                                    </button>
                                </span>
                            );
                        },
                    },
                ],
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding",
                        address: "No.1 Century Avenue, Shanghai",
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
            };
        },
        methods: {
            editRow(rowIndex) {
                alert(`eidt row number:${rowIndex}`);
            },
            deleteRow(rowIndex) {
                this.tableData.splice(rowIndex, 1);
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      .text-bold {
        font-weight: bold;
    }
    </style>
  